export default "__VITE_ASSET__CihyREv5__"